export default __webpack_public_path__ + "static/media/03.eb8bc9f0.jpg";